import * as Sentry from '@sentry/react'

/**
 * Initialize Sentry error tracking
 * Configuration can be customized via environment variables
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE
  const release = import.meta.env.VITE_SENTRY_RELEASE || 'planning-poker@2.0.0'

  // Only initialize if DSN is provided
  if (!dsn) {
    console.warn('Sentry DSN not configured. Error tracking is disabled.')
    return
  }

  Sentry.init({
    dsn,
    environment,
    release,

    // Integration configuration
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Performance Monitoring
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,

    // Session Replay
    replaysSessionSampleRate: environment === 'production' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,

    // Error filtering
    beforeSend(event, hint) {
      // Filter out errors from browser extensions
      if (event.exception) {
        const error = hint.originalException
        if (error && error.stack && error.stack.includes('chrome-extension://')) {
          return null
        }
      }
      return event
    },

    // Enable debug mode in development
    debug: environment === 'development',
  })
}
